module.exports = __webpack_public_path__ + "img/img_file_thumb04.a2e4048a.png";